"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "agoraCameraStatusChanged", {
  enumerable: true,
  get: function get() {
    return _agoraCameraStatusChanged["default"];
  }
});
var _agoraCameraStatusChanged = _interopRequireDefault(require("./agoraCameraStatusChanged"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }